import React from "react";
import { connect } from "react-redux";
import { News } from "../../Permissions/resources";
import { isResourceEditable } from "../../Permissions/actions";
import { PrimaryButtonLink } from "../../../components/Buttons";

const mapStateToProps = (state) => ({
  permissions: state.permissions.permissionMap,
});
const mapDispatchToProps = null;

function NewsMenu({ className = "", categoryName = "general", disabled, permissions }) {
  const isEditable = isResourceEditable(News.Articles, permissions);
  if (disabled || !isEditable) {
    return null;
  }
  let url = "#";
  switch (categoryName) {
    case "Sales":
      url = `/sales/news-feed/beitrag/neu`;
      break;
    default:
      url = `/news-service/beitrag/neu`;
      break;
  }
  return (
    <div className={`news list-menu ${className}`}>
      <PrimaryButtonLink id="createNewsArticleBtn" to={url}>
        {`Beitrag hinzufügen`}
      </PrimaryButtonLink>
    </div>
  );
}

export default connect(mapStateToProps, mapDispatchToProps)(NewsMenu);
